import { GridHeaderCellProps } from '@progress/kendo-react-grid';
import { useContext, useMemo } from 'react';
import { EditCellContext } from 'src/contexts/EditCellContext';
import { InvoiceGlBreakoutItem } from 'src/services/useInvoiceGlBreakoutApi';
import ExpandCollapseCell from './ExpandCollapseCell';

const GLSummaryDetailHeaderCell = (props: GridHeaderCellProps) => {
  const [cellClickFns] = useContext(EditCellContext);
  const { setData, data } = cellClickFns?.(null) as any;
  const isAllExpanded = useMemo(() => data.some((glCode: any) => glCode.expanded), [data]);

  const handleHeaderCellExpand = () => {
    setData((prev: InvoiceGlBreakoutItem[]) =>
      [...prev].map((item) => ({ ...item, expanded: !isAllExpanded }))
    );
  };

  return (
    <th className="k-header k-hierarchy-cell" style={{ borderBottomWidth: '0px' }}>
      <ExpandCollapseCell
        title="Expand/Collapse All"
        expand={isAllExpanded}
        onExpand={handleHeaderCellExpand}
      />
    </th>
  );
};

export default GLSummaryDetailHeaderCell;
